import type { PlatformOptions } from "../../shared/apollo/OneGraphApolloClientProvider";

declare global {

    var graphqlUrl: string | undefined;
    var graphqlIndeedApiKey: string | undefined;

}

/**
 * Resolution order for OneGraph URL and API key:
 *   1. `globalThis.graphqlUrl` / `globalThis.graphqlIndeedApiKey` — host-injected
 *      globals. Matches the convention used by `apps/profile` and `apps/onboarding`,
 *      and the JSF EJS injection added in JSF-628. Preferred for new integrations
 *      (homepage / SERP embed of RNVJ).
 *   2. `window._initialData.oneGraphApi…` — top-level values injected by the JSF
 *      rnw-onegraph page template when the page itself is a
 *      server-rendered ViewJob.
 *   3. `window._initialData.viewJobClientSideModel.oneGraphApi…` — when the values
 *      ride along on the server-rendered ViewJob client-side model instead.
 *   4. `_rootProps.preloadedVJData.oneGraphApi…` — legacy embed via
 *      `mountViewJob({ preloadedVJData })` whose model carries the values.
 */
export function getPlatformOptions(): PlatformOptions {
    // Walk the fallback chain documented above. The host-injected global is passed in
    // directly because its key (graphqlUrl / graphqlIndeedApiKey) differs from the
    // `oneGraphApi…` field used by the other sources.
    const resolve = (hostGlobal: string | undefined, field: 'oneGraphApiUrl' | 'oneGraphApiKey') =>
        hostGlobal ??
        window._initialData?.[field] ??
        window._initialData?.viewJobClientSideModel?.[field] ??
        globalThis._rootProps?.preloadedVJData?.[field];

    return {
        web: {
            graphqlUrl: resolve(globalThis.graphqlUrl, 'oneGraphApiUrl'),
            graphqlApiKey: resolve(globalThis.graphqlIndeedApiKey, 'oneGraphApiKey'),
        },
    };
}
